import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import RMGrid from 'core/grid';
import { localeStrings as strings } from 'applicationConfig';

import ActionLink from 'common/components/ActionLink/ActionLink';

import './transparency.scss';
import { transparencyGridColumns , gridConfig } from './transparencyGridOptions';

@inject('tradingVenuesStore')
@observer
class Transparency extends Component {
  componentWillMount() {
    this.props.tradingVenuesStore.LoadTadingVenues();
  }
  render() {
    const { venues } = this.props.tradingVenuesStore;
    return (
      <div className="transparency-page">
        <div className="transparency-page-body">
          <p>{strings.transparency.welcome}</p>
          <p>{strings.transparency.siteAllow}</p>
          <div className="trading-venues">
            <RMGrid
              columns={transparencyGridColumns}
              rows={venues}
              store={this.props.tradingVenuesStore}
              gridConfig={gridConfig}
            />
          </div>
          <p>{strings.transparency.preAndPostTradeData}</p>

          <p>{strings.transparency.dataDelivered}</p>
          <p className="register-links-container">
            <ActionLink to="/register">
              <span>{strings.transparency.registerWebLink} </span>
              <b>{strings.transparency.webAccess}</b>
            </ActionLink>
            <ActionLink className="register-feed" to="/feed-register">
              <span>{strings.transparency.registerFeedLink} </span>
              <b>{strings.transparency.feedConnection}</b>
            </ActionLink>
            <ActionLink className="register-slice-file" to="/slice-register">
              <span>{strings.transparency.registerSliceFileLink} </span>
              <b>{strings.transparency.sliceFileConnection}</b>
            </ActionLink>
          </p>
        </div>
      </div>
    );
  }
}
export default Transparency;



// WEBPACK FOOTER //
// ./src/containers/Transparency/Transparency.jsx